/* V5.6G-S1: presentation only. Wholesale reads the existing Scrollspy state. */
(() => {
  'use strict';
  if (window.SunvaleGInteractions) { window.SunvaleGInteractions.mount(document); return; }
  const instances = new Map();
  const selector = '[data-sv-g-component]';
  function create(root) {
    const abort = new AbortController(), observers = [], animations = new Set();
    const reduce = matchMedia('(prefers-reduced-motion: reduce)');
    const listen = (el, name, fn) => el.addEventListener(name, fn, {signal: abort.signal});
    const animate = (el, frames) => {
      if (!el || reduce.matches) return;
      const a = el.animate(frames, {duration: 280, easing: 'cubic-bezier(.2,.7,.2,1)'});
      animations.add(a); a.finished.catch(() => {}).finally(() => animations.delete(a));
    };
    let reset = () => {};
    listen(reduce, 'change', () => { animations.forEach(a => a.cancel()); });
    if (root.dataset.svGComponent === 'home') {
      const cells = [...root.querySelectorAll('.sv-hero__signal')];
      let observer;
      function reveal() {
        observer?.disconnect(); root.classList.toggle('g-motion', !reduce.matches);
        cells.forEach((cell, i) => {cell.style.setProperty('--g-order', i);cell.classList.remove('g-seen');});
        if (reduce.matches || !window.IntersectionObserver) return;
        observer = new IntersectionObserver(entries => entries.forEach(e => {
          if (e.isIntersecting) { e.target.classList.add('g-seen'); observer.unobserve(e.target); }
        }), {threshold: .45});
        cells.forEach(cell => observer.observe(cell));
      }
      listen(reduce, 'change', reveal); reveal();
      reset = () => { observer?.disconnect(); root.classList.remove('g-motion'); cells.forEach(c => {c.classList.remove('g-seen');c.style.removeProperty('--g-order');}); };
    }
    if (root.dataset.svGComponent === 'workflow') {
      const links = [...root.querySelectorAll('[data-trade-target]')]; let last;
      function sync() {
        const index = links.findIndex(a => a.dataset.tradeTarget === root.dataset.activeStep);
        root.style.setProperty('--g-progress', Math.max(0,index)/Math.max(1,links.length-1));
        if (last !== root.dataset.activeStep) {
          animate(root.querySelector('[data-workflow-current]'), [{opacity:.7,transform:'translateY(3px)'},{opacity:1,transform:'none'}]);
          last = root.dataset.activeStep;
        }
      }
      const observer = new MutationObserver(sync);
      observer.observe(root,{attributes:true,attributeFilter:['data-active-step']});observers.push(observer);sync();
      reset = () => root.style.removeProperty('--g-progress');
    }
    if (root.dataset.svGComponent === 'custom') {
      const experiment=root.querySelector('.sv-g-direction-experiment'), tabs=[...root.querySelectorAll('[data-direction]')];
      const panels=[...root.querySelectorAll('[data-direction-panel]')], list=root.querySelector('.sv-g-direction-tabs');
      const wide=matchMedia('(min-width:990px)');
      if (!experiment || tabs.length!==4 || panels.length!==4) {abort.abort();return null;}
      function select(index, focus=false) {
        tabs.forEach((t,i)=>{t.setAttribute('role','tab');t.setAttribute('aria-selected',String(i===index));t.tabIndex=i===index?0:-1;
          panels[i].hidden=i!==index;panels[i].inert=i!==index;panels[i].setAttribute('role','tabpanel');panels[i].setAttribute('aria-labelledby',t.id);panels[i].tabIndex=0;});
        root.querySelector('.sv-g-selection-status').textContent=tabs[index].textContent.replace('↗','').trim()+(root.dataset.selectedSuffix||' selected.');
        if(focus) tabs[index].focus({preventScroll:true});
        animate(panels[index].querySelector('.sv-g-direction-copy'),[{opacity:.65,transform:'translateY(4px)'},{opacity:1,transform:'none'}]);
        animate(panels[index].querySelector('img'),[{opacity:.7},{opacity:1}]);
      }
      const orient=()=>list.setAttribute('aria-orientation',wide.matches?'vertical':'horizontal');
      list.setAttribute('role','tablist');orient();listen(wide,'change',orient);
      tabs.forEach((t,i)=>{
        listen(t,'click',()=>select(i));
        listen(t,'keydown',e=>{let next=i;if(['ArrowRight','ArrowDown'].includes(e.key))next=(i+1)%4;else if(['ArrowLeft','ArrowUp'].includes(e.key))next=(i+3)%4;else if(e.key==='Home')next=0;else if(e.key==='End')next=3;else return;e.preventDefault();select(next,true);});
      });
      experiment.classList.add('g-directions-ready');select(0);
      reset=()=>{experiment.classList.remove('g-directions-ready');list.removeAttribute('role');list.removeAttribute('aria-orientation');tabs.forEach(t=>{['role','aria-selected','tabindex'].forEach(a=>t.removeAttribute(a));});panels.forEach(p=>{p.hidden=false;p.inert=false;['role','aria-labelledby','tabindex'].forEach(a=>p.removeAttribute(a));});};
    }
    return {destroy(){abort.abort();observers.forEach(o=>o.disconnect());animations.forEach(a=>a.cancel());reset();}};
  }
  function mount(scope) {
    const roots=[...(scope.matches?.(selector)?[scope]:[]),...scope.querySelectorAll(selector)];
    roots.forEach(root=>{if(!instances.has(root)){const item=create(root);if(item)instances.set(root,item);}});
  }
  function unmount(scope, sectionId) {
    for(const [root,item] of instances) if(scope===root||scope.contains(root)||(sectionId&&root.dataset.svGOwner===sectionId)) {item.destroy();instances.delete(root);}
  }
  window.SunvaleGInteractions={mount,unmount,get count(){return instances.size;}};
  document.addEventListener('shopify:section:load',e=>mount(e.target));
  document.addEventListener('shopify:section:unload',e=>unmount(e.target,e.detail?.sectionId));
  if(document.readyState==='loading')document.addEventListener('DOMContentLoaded',()=>mount(document),{once:true});else mount(document);
})();
